import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { CircularProgress } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import { styled, lighten, darken } from "@mui/system";
const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled("ul")({
  padding: 0,
});

const VariableSizeSelectNested = ({
  options,
  isLoading,
  handleChange,
  defaultValue,
  isDisabled,
  name,
}) => {

  const [selectedItem, setSelectedItem] = useState({
    text: options.find((s) => s.value == defaultValue)?.text == undefined ? "select" : options.find((s) => s.value == defaultValue)?.text,
    value: defaultValue,
  });
  const listboxRef = React.useRef(null);
 
  useEffect(() => {
    const existingObject = options.find((s) => s.value == defaultValue);

    if (existingObject && selectedItem.value != defaultValue)
      setSelectedItem({
        text: existingObject.text,
        value: existingObject.value,
      });
  }, [defaultValue]);
 
  useEffect(() => {
    const existingObject = options.find((s) => s.value == defaultValue);

    if (existingObject && selectedItem.value != defaultValue)
      setSelectedItem({
        text: existingObject.text,
        value: existingObject.value,
      });
  }, [options]);

  const getItemOrSubheader = (params, props, option) => {
    const itemOrSubHeaderList = [];
    itemOrSubHeaderList.push(
      <li {...params} key={props.value} value={props.value}>
        {props.text}
      </li>
    );

     // itemOrSubHeaderList.push(
    //   <MenuItem {...props} key={option?.value} value={option?.value}>
    //     {option.text}
    //   </MenuItem>
    // );

    return itemOrSubHeaderList;
  };

  return (
    <>
      <Autocomplete
        value={selectedItem}
        id="grouped-demo"
        options={options}
        groupBy={(option) => option.groupedName}
        getOptionLabel={(option) => option.text}
        sx={{ width: 300 }}
        onChange={(event, newValue) => {
          if (newValue) {
            handleChange(newValue?.value);
          }
        }}
        disabled={isDisabled}
        renderInput={(params) => (
          <TextField
             className="custom-autocomplete-text-field"
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? (
                    <CircularProgress
                      className="me-5"
                      color="inherit"
                      size={20}
                    />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        renderOption={
          (params, props, option, state) =>
            getItemOrSubheader(params, props, option, state)
        }
        renderGroup={(params) => {
          const { key, group, children } = params;
          const generatedKey = `group-${key}-${group}`;

          return (
            <li key={generatedKey}>
              <GroupHeader>{params.group}</GroupHeader>
              <GroupItems>{params.children}</GroupItems>
            </li>
          );
        }}
      />
    </>
  );
};

export default VariableSizeSelectNested;
